// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"style_page-layout__1CtMX","main-layout":"style_main-layout__h7snA","content":"style_content__yfmaV"};